import { REQUIRED_TEXT_FIELD_VALIDATOR } from '@/helpers/formHelpers/validators';
import { object, ObjectSchema } from 'yup';

interface EditTransactionValidationSchemaType {
  name: string;
}

export const editTransactionValidationSchema: ObjectSchema<EditTransactionValidationSchemaType> = object().shape({
  name: REQUIRED_TEXT_FIELD_VALIDATOR,
});
